import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import type { SelectActionEnum } from 'app/components/pages/HotelMigration/_components/HotelServiceCard/HotelServiceCard';
import { apiMutation } from 'app/utils/request/api';

const mergeHotelPath = '/hotels/:hotelId/merge' as const;

export type IMergePayload = {
  hotelId: number;
  packages: {
    packageId: number;
    action: SelectActionEnum;
  }[];
  experiences: {
    experienceId: number;
    action: SelectActionEnum;
    targetId?: number;
  }[];
  rooms: {
    roomId: number;
    action: SelectActionEnum;
    targetId?: number;
  }[];
};

export function useMergeHotel() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: { hotelId: string; body: IMergePayload }) =>
      apiMutation(
        'POST',
        {
          path: mergeHotelPath,
          params: { hotelId: payload.hotelId },
        },
        payload.body
      ) as Promise<void>,
    onSuccess: () => {
      queryClient.invalidateQueries();
      message.success('Successfully merged hotels');
    },
  });
}
